import Command from '@ckeditor/ckeditor5-core/src/command';
import {createRhDropdown} from "./RhDropdownUtils";

export default class InsertRhDropdownCommand extends Command {
    execute() {
        this.editor.model.change( writer => {
            this.editor.model.insertContent( createRhDropdown( writer ) );
        } );
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent( selection.getFirstPosition(), 'RhDropdown' );

        this.isEnabled = allowedIn !== null;
    }
}
